var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLongitude(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.05493 14.3544C11.9147 14.3544 15.0549 11.1584 15.0549 7.22995C15.0549 3.30151 11.9147 0.105469 8.05493 0.105469C4.19513 0.105469 1.05493 3.30151 1.05493 7.22995C1.05493 11.1584 4.19513 14.3544 8.05493 14.3544ZM8.2738 13.8966V0.563336C10.1624 0.77327 11.6646 3.68291 11.6646 7.22995C11.6646 10.777 10.1624 13.6866 8.2738 13.8966ZM7.83606 0.563336V13.8966C6.97086 13.8006 6.157 13.1361 5.52373 12.0005C4.81533 10.73 4.42473 9.03577 4.42473 7.22995C4.42473 5.42413 4.81486 3.72993 5.52373 2.4594C6.157 1.32376 6.97133 0.659754 7.83606 0.563336ZM14.6177 7.22995C14.6177 10.2944 12.5793 12.883 9.81053 13.6662C10.2338 13.3119 10.6216 12.8255 10.9571 12.2195C11.6954 10.8853 12.1023 9.11319 12.1023 7.22995C12.1023 5.34671 11.6959 3.57462 10.9571 2.24044C10.6216 1.63438 10.2343 1.14802 9.81053 0.793694C12.5793 1.57691 14.6177 4.16547 14.6177 7.22995ZM6.29326 0.795594C5.86906 1.14992 5.48033 1.63486 5.14293 2.23996C4.39766 3.57652 3.987 5.34861 3.987 7.23043C3.987 9.11224 4.39766 10.8843 5.14293 12.2209C5.48033 12.8255 5.86906 13.3109 6.29326 13.6653C3.52733 12.8797 1.4922 10.293 1.4922 7.2309C1.49267 4.16785 3.52733 1.58071 6.29326 0.795594Z",
    fill: "#286248",
    stroke: "#286248",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLongitude);
export default __webpack_public_path__ + "static/media/Longitude.3c45917ef51b2061d78fd2387c64fa3b.svg";
export { ForwardRef as ReactComponent };